// extracted by mini-css-extract-plugin
module.exports = {"background":"Layout_background__3m8bc","container":"Layout_container__232nE"};